import React, { useMemo } from 'react'
import useMerchandiseBrandsList from 'hooks/Merchandise/useMerchandiseBrandsList'
import MerchandiseOfferCarousel from './MerchandiseOfferCarousel'
import useMerchandiseBrand from 'hooks/Merchandise/useMerchandiseBrand'
import { getMerchandiseBrandSearchUrl } from '../merchandiseUtils'
import { FormattedMessage } from 'react-intl'

interface Props {
  brandName: string
  trackingPageName: string
}

function MerchandiseBestOfBrandCarousel({ trackingPageName, brandName }: Props) {
  const [brandsList] = useMerchandiseBrandsList({ name: brandName })
  const [brand] = useMerchandiseBrand(brandsList[0])

  const filters = useMemo(() => {
    if (!brand) return
    return {
      brands: [brand?.id],
    }
  }, [brand])

  const titleConfig = useMemo<{ node: React.ReactNode; tracking: string }>(() => {
    if (!brand) {
      return { node: null, tracking: '' }
    }

    switch (brand.name) {
      case 'Apple':
        return {
          node: (
            <FormattedMessage
              id="FijcZas/4N"
              defaultMessage="Shop the latest from <em>{brandName}</em>"
              description="Title for Apple brand carousel"
              values={{
                brandName: brand.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Shop the latest from ${brand.name}`,
        }
      case 'Smeg':
        return {
          node: (
            <FormattedMessage
              id="ra+wLZ2pC9"
              defaultMessage="Iconic appliances by <em>{brandName}</em>"
              description="Title for Smeg brand carousel"
              values={{
                brandName: brand.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Iconic appliances by ${brand.name}`,
        }
      case 'Samsonite':
        return {
          node: (
            <FormattedMessage
              id="Qh4XSMcew7"
              defaultMessage="Travel in style with <i>{brandName}</i>"
              description="Title for Samsonite brand carousel"
              values={{
                brandName: brand.name,
                i: (chunks) => <i>{chunks}</i>,
              }}
            />
          ),
          tracking: `Travel in style with ${brand.name}`,
        }
      default:
        return {
          node: (
            <FormattedMessage
              id="xwdh+3/tuW"
              defaultMessage="Discover the best of <em>{brandName}</em>"
              description="Title for merchandise brand carousel (default)"
              values={{
                brandName: brand.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Discover the best of ${brand.name}`,
        }
    }
  }, [brand])

  if (brand?.name !== brandName) {
    return null
  }

  return (
    <MerchandiseOfferCarousel
      title={titleConfig.node}
      viewAllTo={getMerchandiseBrandSearchUrl(brand)}
      trackingListName={titleConfig.tracking}
      trackingPageName={trackingPageName}
      filters={filters}
    />
  )
}

export default MerchandiseBestOfBrandCarousel
